import clsx from 'clsx';
import type { CSSProperties } from 'react';

/** Indigo #371168 — Secondary/Indigo token */
const INDIGO = '#371168';
/** Orange 100 fill #ffdbc6 — Primary/Orange 3 token */
const ORANGE_100 = '#ffdbc6';

/**
 * Class names for preference / category pills (Create List categories popover,
 * Recommend This Place travel tags).
 */
export function preferencePillClass(
  selected: boolean,
  options?: { textOnly?: boolean },
): string {
  const textOnly = options?.textOnly;
  return clsx(
    'box-border font-manrope text-[14px] leading-[1.4286] transition-[background,color] duration-150',
    textOnly
      ? 'inline-flex items-center justify-center min-w-10 px-4 py-2 rounded-button cursor-pointer'
      : 'inline-flex items-center gap-2 px-4 py-2 rounded-button cursor-pointer',
    selected
      ? 'text-gray-900 font-bold'
      : 'text-gray-900 font-normal',
  );
}

/**
 * Inline border/background styles for preference pills.
 * Uses inline styles so they can't be overridden by global `button { border: none }` resets.
 */
export function preferencePillStyle(selected: boolean): CSSProperties {
  return selected
    ? { border: `1px solid ${INDIGO}`, background: ORANGE_100 }
    : { border: `1px solid ${INDIGO}`, background: '#ffffff' };
}
